import React from 'react';
import {StyleSheet, TouchableOpacity, View} from 'react-native';

import Text from './ui-controls/Text';

/**
 * ErrorBanner displays recoverable error messages with optional recovery action.
 *
 * DESIGN DECISION: Uses fixed error colors (red palette) intentionally.
 * Error states should be visually distinct from brand theming for accessibility
 * and universal recognition. Red = error is a widely understood convention.
 */
interface ErrorBannerProps {
  message: string;
  action?: {label: string; onPress: () => void} | null;
  testID?: string;
}

export function ErrorBanner({message, action, testID}: ErrorBannerProps) {
  return (
    <View style={styles.container} testID={testID}>
      <Text style={styles.message}>{message}</Text>
      {action ? (
        <TouchableOpacity
          onPress={action.onPress}
          style={styles.actionButton}
          testID={testID ? `${testID}-action` : undefined}>
          <Text style={styles.actionText}>{action.label}</Text>
        </TouchableOpacity>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#FEF2F2',
    borderRadius: 8,
    padding: 16,
    marginVertical: 12,
    borderLeftWidth: 4,
    borderLeftColor: '#DC2626',
  },
  message: {
    color: '#991B1B',
    fontSize: 14,
    lineHeight: 20,
  },
  actionButton: {
    marginTop: 12,
    alignSelf: 'flex-start',
  },
  actionText: {
    color: '#DC2626',
    fontSize: 14,
    fontWeight: '600',
    textDecorationLine: 'underline',
  },
});
